import { Component, ElementRef, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AccountService } from '../accounts/account.service';
import { Router, ActivatedRoute} from '@angular/router';
import { EqualValidator } from './confirm-validator.directive';


@Component({
    providers: [AccountService],
    //templateUrl: 'app/authentication/reset-password.component.html',
    template: require('./reset-password.component.html'),
    directives: [EqualValidator] 
})
 
export class ResetPasswordComponent implements OnInit {

    public alerts: any[];
    public code: any;
    public email: string;
    public answer: string;
    public newPassword: string;
    private sub: any;


    constructor(private router: Router,
        private accountService: AccountService, 
        private route: ActivatedRoute) {}    
 
    ngOnInit() : void{

         this.sub = this.route.queryParams.subscribe(
             params => {
                 this.email = params['email'];
                 this.code = params['code'];
         });
    }


    timeoutAlert(){
        setTimeout(() => {
            this.alerts = [];
            //supposedly not needed in angular2
            //$scope.$apply();
        }, 1000);
    }


    closeAlert(index: number) {
    	this.alerts.splice(index, 1);
  	}

	resetPassword(){
        this.alerts = [];

	    let pwdData = {
		    email: this.email,
			resetToken: this.code,
			newPassword: this.newPassword
		};

		this.accountService.resetPwd(pwdData)
            .subscribe(
                data => {
                    if(data.succeeded){
                        this.router.navigate(['/reset-password-success']);
                    }else{
						this.alerts.push({type: 'danger', msg: data.errors[0]});
					}
                },
                error => {
                    this.alerts.push({type: 'danger', msg: 'An error occurred resetting your password. Please try again'});    
                },
                () => this.timeoutAlert()

            );
  	}
}





/** WEBPACK FOOTER **
 ** ./app/authentication/reset-password.component.ts
 **/